import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import resourcesToBackend from 'i18next-resources-to-backend'
import captureError from '@disco/utils/captureError'

i18next
  .use(initReactI18next)
  .use(
    resourcesToBackend((language: string, namespace: string) => {
      switch (process.env.NODE_ENV) {
        case 'development': {
          // Use local dynamic import in dev to support hot reloading
          return import(
            `../../frontend/assets/locales/${language}/${namespace}.json`
          ).catch(() => {
            console.error(
              '[i18n] could not load language/namespace in frontend/assets/locales',
              { language, namespace },
            )
          })
        }
        default: {
          const localesBaseUrl = process.env.PUBLIC_PATH || '/'
          const localesUrl = `${localesBaseUrl}locales/${language}/${namespace}.json`

          return fetch(localesUrl)
            .then(res => {
              if (!res.ok) {
                throw new Error(`${res.status} ${res.statusText}`)
              }

              return res.json()
            })
            .catch(error => {
              captureError(error, {
                moduleName: 'i18n',
                description:
                  '[i18n] could not load language/namespace from locales CDN',
                extra: {
                  localesBaseUrl,
                  language,
                  namespace,
                  error,
                },
              })
            })
        }
      }
    }),
  )
  .init({
    returnEmptyString: false,
    fallbackLng: 'en',
    defaultNS: false,
  })

export default i18next
